












import { Vue, Component, Prop } from 'vue-property-decorator';
import { BrowserDatamatrixCodeReader } from '@zxing/library';
import CameraPermissionErrorDialog from './CameraPermissionErrorDialog.vue';
import { FetchResult, ImageMarkType, IUpdateOdpInfoPayload } from '../../store';
import { getIsDefaultEmphasize, getCameraDeviceId } from '../../services/UserSettingService';
import OdpReadErrorDialog from './OdpReadErrorDialog.vue';
import { Messages } from '../../constants/Messages';
import appConfig from '../../appConfig';

@Component({
    components: {
        CameraPermissionErrorDialog,
        OdpReadErrorDialog,
    },
})
export default class DataMatrixReader extends Vue {
    @Prop() public readonly handleDecode!: () => void;

    public isCameraPermission = false;
    public isOdpReadError = false;
    public errorText = '';
    private isEmphasized = getIsDefaultEmphasize();
    private codeReader = new BrowserDatamatrixCodeReader();

    // チラシに印刷されている二次元バーコードから読み取れるシリアルコード
    private readonly pamphletSerialCode: string = "2980180049874730000000252991000022992jHjMT02X5wRAB+qdjVCClw==29";

    public mounted() {
        this.handleCodeReader();
    }

    private beforeDestroy() {
        this.codeReader.reset();
    }

    private permissionError() {
        this.isCameraPermission = true;
    }

    private getImageMarkType() {
        return this.isEmphasized ? ImageMarkType.Emphasized : ImageMarkType.Normal;
    }

    private get fetchResult() {
        return this.$store.state.fetchResult;
    }

    private handleCodeReader() {
        // 2回目以降のダイアログ表示のため、フラグをオフにする
        this.isOdpReadError = false;

        var deviceId = getCameraDeviceId();
        this.codeReader
            .decodeFromInputVideoDevice(deviceId == null ? undefined : deviceId, 'video')
            .then((result) => {
                const serialCode = result.getText()
                    .replace(this.pamphletSerialCode, appConfig.demoDataSerialCode); // チラシから読み込んだシリアルコードだった場合、各クラウド環境に合ったデモ用シリアルコードに置換する

                this.$store.dispatch('updateOdpInfoAction', {
                    serialCode,
                } as IUpdateOdpInfoPayload)
                    .then(() => {
                        switch (this.fetchResult) {
                            case FetchResult.Success:
                                this.handleDecode();
                                break;
                            case FetchResult.Old:
                                this.errorText = Messages.Dialog.OldPackage;
                                this.isOdpReadError = true;
                                break;
                            case FetchResult.NotFound:
                                this.errorText = Messages.Dialog.NotFoundPackage;
                                this.isOdpReadError = true;
                                break;
                            case FetchResult.InvalidSerialCode:
                                this.errorText = Messages.Dialog.InvalidSerialCode;
                                this.isOdpReadError = true;
                                break;
                            case FetchResult.Error:
                                this.errorText = Messages.Dialog.AccessError;
                                this.isOdpReadError = true;
                                break;
                            default:
                                this.errorText = Messages.Dialog.AccessError;
                                this.isOdpReadError = true;
                        }
                    });
            })
            .catch((err) => {
                console.error(err);
                this.permissionError()
            });
    }

    private handleClose() {
        this.isCameraPermission = false;
    }
}
